import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { login as loginApi } from '@/api/auth'

export const useUserStore = defineStore('user', () => {
  const token = ref<string | null>(localStorage.getItem('token'))
  const username = ref<string>('')

  const isLoggedIn = computed(() => !!token.value)

  async function login(loginUsername: string, password: string) {
    try {
      const res = await loginApi({ username: loginUsername, password })
      const { token: newToken, username: returnedUsername } = res.data
      token.value = newToken
      username.value = returnedUsername || loginUsername
      localStorage.setItem('token', newToken)
      return true
    } catch (error: any) {
      return false
    }
  }

  function logout() {
    token.value = null
    username.value = ''
    localStorage.removeItem('token')
  }

  return { token, username, isLoggedIn, login, logout }
})
